var $5f3754867e416768$exports = {};
$5f3754867e416768$exports = {
  "backButton": args => "Atgriezties uz ".concat(args.prevMenuButton),
  "moreActions": "Citas darb\u012Bbas",
  "unavailable": "Nav pieejams, izv\u0113rsiet, lai skat\u012Btu s\u012Bk\u0101ku inform\u0101ciju"
};
export { $5f3754867e416768$exports as default };